import { render } from "./ev1TabTwo.vue?vue&type=template&id=cb062144&scoped=true"
import script from "./ev1TabTwo.vue?vue&type=script&lang=js"
export * from "./ev1TabTwo.vue?vue&type=script&lang=js"

import "./ev1TabTwo.vue?vue&type=style&index=0&id=cb062144&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb062144"]])

export default __exports__